import { Printer, X } from 'lucide-react';
import { POS_Z_CLASS } from '../../utils/posZLayers';
import {
  buildDuplicataPreviewModel,
  triggerDuplicataWindowPrint,
} from '../../utils/caisseDuplicataDocument.js';
import DuplicataTicketBody from './DuplicataTicketBody.jsx';
import '../../styles/caisse-duplicata-print.css';

/**
 * Aperçu duplicata intégré — fermeture explicite (iPad plein écran / PWA).
 */
export default function CaisseDuplicataPreviewModal({
  open,
  ticket,
  display,
  formatMoney,
  commercant,
  onClose,
  backLabel = "Retour à l'historique",
}) {
  if (!open || !ticket) return null;

  const model = buildDuplicataPreviewModel(ticket, display, formatMoney, commercant);

  const handlePrint = () => {
    triggerDuplicataWindowPrint();
  };

  return (
    <>
      <div
        id="caisse-duplicata-print-root"
        data-testid="caisse-duplicata-print-root"
        aria-hidden="true"
        className="pointer-events-none fixed left-[-9999px] top-0 w-[80mm] bg-white p-3"
      >
        <DuplicataTicketBody model={model} testIdPrefix="caisse-duplicata-print" />
      </div>

      <div
        className={`fixed inset-0 ${POS_Z_CLASS.modalDuplicata} flex flex-col bg-slate-900/60 print:hidden`}
        role="presentation"
        data-testid="caisse-duplicata-preview-backdrop"
      >
        <div
          className="flex flex-col flex-1 min-h-0 bg-white mt-[env(safe-area-inset-top)] mb-0 sm:my-6 sm:mx-auto sm:max-w-lg sm:rounded-2xl sm:shadow-2xl sm:max-h-[calc(100dvh-3rem)]"
          role="dialog"
          aria-modal="true"
          aria-labelledby="caisse-duplicata-title"
          data-testid="caisse-duplicata-preview"
          onClick={(e) => e.stopPropagation()}
        >
          <header className="shrink-0 flex items-center justify-between gap-3 px-4 py-4 border-b border-slate-100 pb-[max(1rem,env(safe-area-inset-top))] sm:pb-4">
            <div className="min-w-0">
              <h2 id="caisse-duplicata-title" className="text-lg font-bold text-slate-900 truncate">
                Duplicata de ticket
              </h2>
              <p className="text-xs text-slate-500 truncate">Ticket {model.numero}</p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="shrink-0 min-h-[48px] min-w-[48px] flex items-center justify-center rounded-xl bg-slate-100 text-slate-700 hover:bg-slate-200"
              aria-label="Fermer l'aperçu duplicata"
              data-testid="caisse-duplicata-close"
            >
              <X className="h-6 w-6" />
            </button>
          </header>

          <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4">
            <DuplicataTicketBody model={model} />
          </div>

          <footer className="shrink-0 flex flex-col sm:flex-row gap-3 px-4 py-4 border-t border-slate-100 pb-[max(1rem,env(safe-area-inset-bottom))]">
            <button
              type="button"
              onClick={handlePrint}
              className="flex-1 min-h-[52px] px-4 py-3 rounded-xl bg-emerald-600 text-white font-semibold hover:bg-emerald-700 flex items-center justify-center gap-2"
              data-testid="caisse-duplicata-print"
            >
              <Printer className="h-5 w-5" aria-hidden />
              Imprimer
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 min-h-[52px] px-4 py-3 rounded-xl bg-slate-100 text-slate-800 font-semibold hover:bg-slate-200"
              data-testid="caisse-duplicata-back"
            >
              {backLabel}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
}
